import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconVga24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="26"
            height="24"
            viewBox="0 0 26 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="VGA">
            <path
                d="M7 11C7.55228 11 8 10.5523 8 10C8 9.44772 7.55228 9 7 9C6.44771 9 6 9.44772 6 10C6 10.5523 6.44771 11 7 11Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M11 11C11.5523 11 12 10.5523 12 10C12 9.44772 11.5523 9 11 9C10.4477 9 10 9.44772 10 10C10 10.5523 10.4477 11 11 11Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M16 10C16 10.5523 15.5523 11 15 11C14.4477 11 14 10.5523 14 10C14 9.44772 14.4477 9 15 9C15.5523 9 16 9.44772 16 10Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M19 11C19.5523 11 20 10.5523 20 10C20 9.44772 19.5523 9 19 9C18.4477 9 18 9.44772 18 10C18 10.5523 18.4477 11 19 11Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M10 14C10 14.5523 9.55228 15 9 15C8.44771 15 8 14.5523 8 14C8 13.4477 8.44771 13 9 13C9.55228 13 10 13.4477 10 14Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M13 15C13.5523 15 14 14.5523 14 14C14 13.4477 13.5523 13 13 13C12.4477 13 12 13.4477 12 14C12 14.5523 12.4477 15 13 15Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M18 14C18 14.5523 17.5523 15 17 15C16.4477 15 16 14.5523 16 14C16 13.4477 16.4477 13 17 13C17.5523 13 18 13.4477 18 14Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.946252 8.73649L2.97223 16.7365C3.30934 18.0677 4.50723 19 5.88042 19H20.1196C21.4928 19 22.6907 18.0677 23.0278 16.7365L25.0537 8.73649C25.5338 6.84084 24.101 5 22.1456 5H3.85444C1.89895 5 0.466185 6.84084 0.946252 8.73649ZM4.91102 16.2455L2.88505 8.2455C2.72502 7.61361 3.20261 7 3.85444 7H22.1456C22.7974 7 23.275 7.61361 23.115 8.2455L21.089 16.2455C20.9766 16.6892 20.5773 17 20.1196 17H5.88042C5.42269 17 5.02339 16.6892 4.91102 16.2455Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
